import { render, staticRenderFns } from "./TheLayoutToolbar.vue?vue&type=template&id=0c0bc6c4&scoped=true"
import script from "./TheLayoutToolbar.vue?vue&type=script&lang=js"
export * from "./TheLayoutToolbar.vue?vue&type=script&lang=js"
import style0 from "./TheLayoutToolbar.vue?vue&type=style&index=0&id=0c0bc6c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c0bc6c4",
  null
  
)

export default component.exports